// import React, { useState } from 'react';
// import { Link } from 'react-router-dom'; 
// import logoImage from '../assets/IMG2.png';
// import mobileLogoImage from '../assets/IMG2.png';
// import '../components/Header.css'


// export default function Header() {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);

//   const toggleMenu = () => {
//     setIsMenuOpen(!isMenuOpen);
//   };

//   return (
//     <header className="bg-transparent fixed top-0 left-0 right-0 flex items-center p-4 z-50">
//       {/* Desktop Logo Container */}
//       <div className="hidden md:flex flex-shrink-0 -mt-3 ml-5">
//         <img src={logoImage} alt="Logo" className="w-32" />
//       </div>

//       {/* Mobile Logo Container */}
//       <div className="md:hidden absolute left-1/2 transform -translate-x-1/2 -mt-1">
//         <img src={mobileLogoImage} alt="Mobile Logo" className="w-32" />
//       </div>

//       {/* Navigation Container */}
//       <div className="flex-grow flex justify-end md:justify-center relative -mt-3">
//         <nav
//           className={`${
//             isMenuOpen ? 'block' : 'hidden'
//           } absolute right-0 top-1/2 transform -translate-y-1/2 md:relative md:flex md:justify-center md:items-center space-x-8 bg-gray-800 bg-opacity-90 md:bg-transparent p-4 md:p-0 z-50 -ml-20`}
//         >
//           {/* Navigation Links */}
//           <Link to="/" style={{ color: '#0489A6' }} className="font-bold text-m hover:text-gray-300">Home</Link>
//           <Link to="/about" style={{ color: '#0489A6' }} className="font-bold text-m hover:text-gray-300">About Us</Link>
//           <Link to="/contact" style={{ color: '#0489A6' }} className="font-bold text-m hover:text-gray-300">Contact</Link>
//           <Link to="/login" style={{ color: '#0489A6' }} className="font-bold text-m hover:text-gray-300">Log in</Link>
//           <Link to="/signin" style={{ color: '#0489A6' }} className="font-bold text-m hover:text-gray-300">Sign in</Link>
//         </nav>
//       </div>

//       {/* Mobile Menu Button */}
//       <button
//         className="md:hidden flex items-center text-white hover:text-gray-300 ml-auto"
//         onClick={toggleMenu}
//       >
//         <svg
//           className="w-6 h-6"
//           fill="none"
//           stroke="currentColor"
//           viewBox="0 0 24 24"
//           xmlns="http://www.w3.org/2000/svg"
//         >
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             strokeWidth="2"
//             d="M4 6h16M4 12h16M4 18h16"
//           />
//         </svg>
//       </button>
//     </header>
//   );
// }


import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaUser, FaBars, FaTimes, FaHome, FaInfoCircle, FaEnvelope } from 'react-icons/fa';

const Header = () => {
  const navigate = useNavigate();
  const [isNavbarVisible, setIsNavbarVisible] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollTop = window.pageYOffset;
      
      // Enhanced scroll behavior
      if (currentScrollTop > lastScrollY && currentScrollTop > 100) {
        setIsNavbarVisible(false);
      } else {
        setIsNavbarVisible(true);
      }
      
      // Add background blur when scrolled
      setIsScrolled(currentScrollTop > 20);
      setLastScrollY(currentScrollTop);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  const handleLoginClick = () => {
    navigate('/login');
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleLinkClick = () => {
    setIsMobileMenuOpen(false);
  };

  const navItems = [
    { to: '/', label: 'Home', icon: FaHome },
    { to: '/initial-about-us', label: 'About Us', icon: FaInfoCircle },
    { to: '/initial-contact-us', label: 'Contact Us', icon: FaEnvelope }
  ];

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ease-out ${
          isNavbarVisible ? 'translate-y-0' : '-translate-y-full'
        }`}
      >
        <div className="flex justify-center p-4">
          <div className={`
            flex items-center justify-between w-full max-w-6xl
            ${isScrolled 
              ? 'bg-white/10 backdrop-blur-xl border border-white/20 shadow-2xl' 
              : 'bg-white/5 backdrop-blur-md border border-white/10 shadow-lg'
            }
            rounded-2xl px-6 py-3 transition-all duration-300 ease-in-out
            hover:bg-white/15 hover:shadow-2xl
          `}>
            
            {/* Logo Section */}
            <div className="flex items-center group">
              <Link to="/" className="flex items-center space-x-3" onClick={handleLinkClick}>
                <div className="relative">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-400 to-purple-600 rounded-full flex items-center justify-center shadow-lg transform group-hover:scale-110 transition-transform duration-300">
                    <span className="text-white font-bold text-xl">L</span>
                  </div>
                  <div className="absolute -top-1 -right-1 w-4 h-4 bg-yellow-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
                <span className="hidden sm:block text-white font-bold text-xl bg-gradient-to-r from-white to-blue-200 bg-clip-text text-transparent">
                  Brand
                </span>
              </Link>
            </div>

            {/* Desktop Navigation */}
            <ul className="hidden lg:flex items-center space-x-1">
              {navItems.map((item, index) => (
                <li key={index} className="relative group">
                  <Link
                    to={item.to}
                    className="flex items-center space-x-2 px-4 py-2 text-black font-medium rounded-xl hover:bg-white/20 transition-all duration-300 ease-in-out transform hover:scale-105"
                    onClick={handleLinkClick}
                  >
                    <item.icon className="w-4 h-4" />
                    <span>{item.label}</span>
                  </Link>
                  <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-blue-400 to-purple-600 group-hover:w-full transition-all duration-300"></div>
                </li>
              ))}
            </ul>

            {/* Desktop Login Button */}
            <div className="hidden lg:flex items-center">
              <button
                onClick={handleLoginClick}
                className="group flex items-center space-x-2 px-6 py-2.5 text-white font-semibold bg-gradient-to-r from-blue-600 to-purple-600 rounded-full hover:from-blue-700 hover:to-purple-700 transition-all duration-300 ease-in-out transform hover:scale-105 hover:shadow-lg shadow-md"
              >
                <FaUser className="w-4 h-4 group-hover:rotate-12 transition-transform duration-300" />
                <span>Login</span>
              </button>
            </div>

            {/* Mobile Menu Button */}
            <div className="lg:hidden">
              <button
                onClick={toggleMobileMenu}
                className="p-2 text-white hover:bg-white/10 rounded-full transition-all duration-300 transform hover:scale-110"
                aria-label="Toggle menu"
              >
                {isMobileMenuOpen ? (
                  <FaTimes className="w-6 h-6" />
                ) : (
                  <FaBars className="w-6 h-6" />
                )}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        <div
          className={`lg:hidden absolute top-full left-4 right-4 transition-all duration-300 ease-out ${
            isMobileMenuOpen
              ? 'opacity-100 translate-y-0 pointer-events-auto'
              : 'opacity-0 -translate-y-4 pointer-events-none'
          }`}
        >
          <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl shadow-2xl overflow-hidden">
            <ul className="py-4">
              {navItems.map((item, index) => (
                <li key={index} className="mx-2 mb-1">
                  <Link
                    to={item.to}
                    onClick={handleLinkClick}
                    className="flex items-center space-x-3 px-4 py-3 text-black font-medium rounded-xl hover:bg-white/20 transition-all duration-300 transform hover:translate-x-1"
                  >
                    <item.icon className="w-5 h-5" />
                    <span>{item.label}</span>
                  </Link>
                </li>
              ))}
              <li className="mx-2 mt-4 pt-4 border-t border-white/20">
                <button
                  onClick={handleLoginClick}
                  className="w-full flex items-center justify-center space-x-2 px-4 py-3 text-white font-semibold bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl hover:from-blue-700 hover:to-purple-700 transition-all duration-300 transform hover:scale-105"
                >
                  <FaUser className="w-4 h-4" />
                  <span>Login</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40 lg:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </>
  );
};

export default Header;